export default "__VITE_PUBLIC_ASSET__453fcbcb__"